import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../common/Header/Header";
import Footer from "../common/Footer/Footer";
import TherapistDetail from "../components/TherapistInfo/TherapistDetail";
import SEO from "../components/SEO/SEO";

const TherapistInfoPage = () => {
  const { id } = useParams();
  const therapist = useSelector((state) => state.therapist?.therapistDetail);

  const therapistName = therapist
    ? `${therapist.name} ${therapist.surname}`
    : "Therapist Profile";

  const expertises = therapist?.expertisesTags?.map((t) => t.name).join(", ");
  const description = therapist
    ? `Book a session with ${therapistName}${expertises ? ` — specializing in ${expertises}` : ""}. Online therapy, confidential and professional.`
    : "View therapist profile and book an online therapy session on MindTherapy Counselling.";

  return (
    <div>
      <SEO
        title={therapistName}
        description={description}
        canonical={`https://mindtherapycounselling.com/therapistInfo/${id}`}
        ogType="profile"
        ogImage={therapist?.profilePhoto || undefined}
      />
      <Header />
      <TherapistDetail />
      {/* <ExpertSlider /> */}
      <Footer />
    </div>
  );
};

export default TherapistInfoPage;
